import { render, staticRenderFns } from "./detail-log.vue?vue&type=template&id=329aefb6&scoped=true"
import script from "./detail-log.vue?vue&type=script&lang=js"
export * from "./detail-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329aefb6",
  null
  
)

export default component.exports